import { ChangeDetectionStrategy, Component, Input, inject, Renderer2, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { AnswerSwitchTypePipe } from './answer-switch-type.pipe';
import { QuestionTitlePipe } from '../components/question-title.pipe';
import { combineLatest, filter, map } from 'rxjs';
import { MiniContactDisplayComponent } from 'src/app/features/users/components/mini-contact-display/mini-contact-display.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { QuestionData } from 'src/app/models/QuestionnaireDataByQuestions.model';
import { AnswerByRecipientComponent } from './answer-by-recipient/answer-by-recipient.component';
import { Recipient } from 'src/app/models/recipients.model';
import { Router } from '@angular/router';

@Component({
    selector: 'que-genery-column',
    imports: [CommonModule, AnswerSwitchTypePipe, QuestionTitlePipe, MiniContactDisplayComponent, TranslateDirective, TranslatePipe, AnswerByRecipientComponent],
    templateUrl: './genery-column.component.html',
    styleUrls: ['./genery-column.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeneryColumnComponent {
  @Input()
  questionData?:QuestionData;
  @Input()
  type: string = 'regular';
  #storeData = inject(DataSummaryStore);
  #router = inject(Router);
  recipients$ = toSignal(this.#storeData.filterRecipientsByReply$);

  showComparison$ =toSignal( this.#storeData.showComparison$);

  //numberRange: number[] = Array.from({ length: 40 }, (_, i) => i + 1);
  //.pipe(filter(x=>x!=undefined),map(x=>{return [...x!,...x!,...x!,...x!,...x!]}));
  constructor(private renderer: Renderer2, private el: ElementRef) { }

  viewSubmission(recipient?: Recipient) {
    if (recipient?.guidToUser) {
      this.#router.navigate(['viewAnswers', recipient.guidToUser, 0]);
    }
  }
}
